const localeWithRegionByLocale = {
  fr: 'fr_FR',
  es: 'es_ES',
  it: 'it_IT',
  de: 'de_DE',
  nl: 'nl_NL',
  ca: 'ca_ES',
  da: 'da_DK',
  en: 'en_US',
  no: 'no_NO',
  pt: 'pt_PT',
  sv: 'sv_SE'
} as const

export default function getLocaleWithRegion(locale: string) {
  return localeWithRegionByLocale[locale] ?? localeWithRegionByLocale.en
}
